<app-static-page-layout pageTitle="Terms and Conditions">
  <div class="terms-content">
    <!-- Logo Section -->
    <section class="logo-section">
      <div class="ciranet-logo">
        <app-icon
          name="ciranet-logo"
          size="100%"
          ariaLabel="CiraNet Logo"
        ></app-icon>
      </div>
      <div class="realmanage-logo">
        <app-icon
          name="realmanage-logo"
          size="100%"
          ariaLabel="RealManage Logo"
        ></app-icon>
      </div>
    </section>

    <!-- Terms Content -->
    <section class="terms-body">
      <article class="terms-section">
        <p class="last-updated">Last Updated: August 21, 2025</p>
        <p class="legal-notice">
          PLEASE READ THESE ONLINE TERMS AND CONDITIONS OF USE (THE "AGREEMENT")
          CAREFULLY BEFORE USING THE HTTPS://REALMANAGE.COM OR
          HTTPS://CIRANET.COM WEBSITE. BY ACCESSING, USING OR DOWNLOADING
          MATERIALS FROM THESE WEBSITES, YOU AGREE TO BE BOUND BY THESE TERMS
          AND CONDITIONS JUST AS IF YOU HAD SIGNED THIS AGREEMENT. IF YOU DO NOT
          AGREE TO BE BOUND BY THIS AGREEMENT, DO NOT USE THIS WEBSITE.
        </p>
      </article>

      <article class="terms-section">
        <h2>Ownership of Website and Restrictions on Use</h2>
        <p>
          RealManage, LLC and its related companies, affiliates and subsidiaries
          (collectively, "RealManage," "Company," "we," "our," or "us"). The
          Company is the owner of this website (the "Website"). This Website
          contains information including, without limitation, all text,
          graphics, logos, icons, images, audio and video clips, digital
          downloads, data compilations, page headers, and software
          (collectively, "Content" or "Information"), that is either owned or
          licensed by the Company. The Company grants you a personal, limited,
          non-exclusive and revocable license to access this website solely for
          your non-commercial use. No other uses of the Content are authorized
          or permitted without the Company's express written consent.
        </p>
        <p>
          As a condition of your use of this Website, you represent, warrant and
          agree to the following:
        </p>
        <ul>
          <li>
            You will not use this Website for any purpose that is unlawful,
            prohibited by the terms of this Agreement, to facilitate unfair
            competition with the Website, or a violation of the rights of any
            third party.
          </li>
          <li>
            You otherwise control all the rights to all data and information
            that you post or send to us and that all such information is
            accurate.
          </li>
          <li>
            You agree to use the Website and Content for lawful purposes only
            and you will not attempt to gain unauthorized access to any portions
            of this Website, other accounts, computer systems or networks
            connected to any Company server, through hacking, password mining or
            any other means.
          </li>
          <li>Your use of the Website will not cause injury to anyone.</li>
          <li>
            You will not obtain or attempt to obtain any materials or
            information through any means not intentionally made available
            through this Website.
          </li>
          <li>
            You will not use any of the Company's proprietary logos, marks, or
            other distinctive graphics, audio, or video material in your links
            without the Company's express written consent, which the Company may
            withhold in its sole discretion.
          </li>
          <li>
            You may not link our Content in any manner that is likely to imply
            an affiliation with or an endorsement or sponsorship by the Company,
            that is likely to cause confusion or deception or otherwise violate
            state or federal law.
          </li>
          <li>
            You agree not to post or transmit any information through the
            Website which:
            <ul>
              <li>
                is unlawful, threatening, abusive, defamatory, libelous, vulgar,
                obscene, profane, indecent or otherwise objectionable
              </li>
              <li>
                contains unauthorized or malicious software such as viruses;
                and,
              </li>
              <li>
                is protected by copyright, trademark or other proprietary right
                without the express written consent of the owner of such right.
              </li>
            </ul>
          </li>
          <li>
            You agree that you shall be solely liable for any damages resulting
            from any infringement of copyright, trademark or other proprietary
            right, or any other harm resulting from your use of the Website or
            Content.
          </li>
          <li>
            You understand that we have the right (but no obligation) to
            monitor, edit or remove any activity or content involving you and
            that the use of the Website, authorized or unauthorized, constitutes
            consent to such monitoring.
          </li>
          <li>
            You understand that we have no responsibility and assume no
            liability for any information or data posted or transmitted by you
            or by anyone else.
          </li>
          <li>
            You understand that you may be issued a user ID and/or password or
            other positive identifier to utilize certain portions of this
            Website and you are entirely responsible for maintaining the
            confidentiality of your password. Furthermore, you agree to notify
            the Company immediately of any unauthorized use of your account or
            any other breach of security. The Company will not be liable for any
            loss that you may incur as a result of such unauthorized use or
            breach regardless of whether it happened with or without your
            knowledge. Moreover, you could be held liable for losses incurred by
            the Company or any party due to someone else using your password.
          </li>
        </ul>
        <p>
          The Website may contain links to other websites that are provided for
          informational purposes only. Unless expressly stated, the Company does
          not sponsor or affiliate with any linked entity on the Website and
          makes no representations and assumes no responsibility for your use of
          links provided on the Website.
        </p>
        <p>
          The Company shall not be liable for any loss resulting, directly or
          indirectly, from delays or interruptions in services due to electronic
          or mechanical equipment failures, telephone interconnect problems,
          defects, strikes, walkouts, weather, fire, acts of God, riots, armed
          conflicts, acts of war, or due to other like causes beyond the
          reasonable control of the Company. Furthermore, the Company shall have
          no responsibility to provide you with access to the Website while
          interruption of the Website due to any such case continues.
        </p>
      </article>

      <article class="terms-section">
        <h2>Termination</h2>
        <p>
          The Company may terminate or suspend your access to the Website
          immediately, without prior notice or liability, under its sole
          discretion, for any reason whatsoever and without limitation,
          including but not limited to a breach of this Agreement. Termination
          or cancellation of this Agreement shall not affect any right or relief
          to which the Company may be entitled. Upon termination of this
          Agreement, all rights granted to you will terminate and revert to the
          Company. All provisions of this Agreement shall survive termination,
          including, without limitation, ownership provisions, indemnity,
          limitations of liability and warranty disclaimers.
        </p>
      </article>

      <article class="terms-section">
        <h2>Indemnification</h2>
        <p class="legal-notice">
          YOU AGREE TO RELEASE, INDEMNIFY, DEFEND AND HOLD HARMLESS THE COMPANY,
          ITS AFFILIATES AND SUBSIDIARIES, ITS LICENSORS AND THEIR AFFILIATES,
          OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS, AGENTS, OFFICERS AND
          DIRECTORS (THE "COMPANY PARTIES"), FROM AND AGAINST ANY AND ALL
          CLAIMS, DAMAGES, OBLIGATIONS, LOSSES, LIABILITIES, COSTS OR DEBT,
          FINES, PENALTIES AND EXPENSES (INCLUDING BUT NOT LIMITED TO ATTORNEY'S
          FEES AND EXPENSES) RESULTING FROM OR OUT OF YOUR USE AND ACCESS OF THE
          WEBSITE AND INFORMATION OR A BREACH OF THESE TERMS, EVEN IF CAUSED, IN
          WHOLE OR IN PART, BY THE JOINT, SOLE OR CONCURRENT NEGLIGENCE, GROSS
          NEGLIGENCE, STRICT LIABILITY OR OTHER FAULT, WHETHER PASSIVE OR
          ACTIVE, OF ANY PERSON OR ENTITY, INCLUDING BUT NOT LIMITED TO THE
          COMPANY PARTIES.
        </p>
      </article>

      <article class="terms-section">
        <h2>Limitation of Liability</h2>
        <p class="legal-notice">
          YOU AGREE THAT THE COMPANY, ITS AFFILIATES AND SUBSIDIARIES, ITS
          LICENSORS AND THEIR AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES,
          PARTNERS, AGENTS, AFFILIATES, CONTRACTORS OR REPRESENTATIVES, SHALL
          NOT IN ANY EVENT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
          CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING OUT OF THE USE OR INABILITY
          TO USE THE WEBSITE AND INFORMATION FOR ANY PURPOSE WHATSOEVER,
          INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, GOODWILL, OR
          OTHER INTANGIBLE LOSSES. THE PROVISIONS CONTAINED IN THIS SECTION
          SHALL SURVIVE TERMINATION OF THIS AGREEMENT.
        </p>
      </article>

      <article class="terms-section">
        <h2>Warranty Disclaimer</h2>
        <p>
          You acknowledge that your use of the Website is at your sole risk. You
          acknowledge that the Website and Information are provided to you on an
          "AS IS, WITH ALL FAULTS" and "AS AVAILABLE" basis. The Company and its
          licensors expressly disclaim any and all warranties, whether express,
          oral, implied, statutory or otherwise, including any implied warranty
          of fitness for a particular purpose, any implied warranty of
          merchantability, any warranties arising by virtue of custom of trade
          or course of dealing and any implied warranties of title,
          non-infringement or course of performance. Further, the Company, its
          subsidiaries, affiliates, and its licensors do not warrant that a) the
          Website will function uninterrupted, secure or available at any
          particular time or location; b) any errors or defects will be
          corrected; c) the Website is free of viruses or other harmful
          components; or d) the Website or Information will meet your
          requirements or are suitable for your needs. Under this Agreement, you
          assume all risk of errors and/or omissions on the Website and
          Information, including the transmission or translation of Information.
        </p>
      </article>

      <article class="terms-section">
        <h2>Governing Law</h2>
        <p>
          This Agreement shall be governed and construed in accordance with the
          laws of the State of Texas, excluding any rule or principle that would
          refer to and apply the substantive law of another state or
          jurisdiction. Any claim or cause of action shall be brought
          exclusively in the state or federal courts located in Plano, Collin
          County, Texas, and you agree to submit to the exclusive personal
          jurisdiction of such courts and hereby appoint the Secretary of State
          of Texas as your agent for service of process. You agree to waive any
          objection that the state or federal courts of Collin County, Texas,
          are an inconvenient forum. Our failure to enforce any right or
          provision of this Agreement will not be considered a waiver of those
          rights. If any provision of these Terms is held to be invalid or
          unenforceable by a court, the remaining provisions of the Agreement
          will remain in effect. This Agreement constitutes the entire agreement
          between us regarding our Terms of Use and supersedes and replaces any
          prior agreements we might have had between us regarding the Terms of
          Use.
        </p>
      </article>

      <article class="terms-section">
        <h2>Modifications</h2>
        <p>
          The Company reserves the right, at its sole discretion, to modify the
          terms and conditions of this Agreement at any time. Such modifications
          may include, without limitation, implementation of user priorities,
          implementation of rules for use by you, discontinuance of functional
          aspects of the Website, addition, withdrawal or modification of
          Content within the Website or services provided through the Website.
          All such modifications shall be displayed online, and such display
          shall constitute effective notice under this Agreement on the day the
          Company places them on the Website. By continuing to access or use our
          Website after any modifications become effective, you agree to be
          bound by the revised terms. You agree to review the terms and
          conditions of this Agreement periodically to be aware of such
          revisions. If you do not agree to the new terms, you are no longer
          authorized to use the Service.
        </p>
      </article>

      <article class="terms-section">
        <h2>Contact Us</h2>
        <p>
          For any questions or comments about this Terms and Conditions of Use
          Agreement, please feel free to contact us at any time by emailing
          <a href="mailto:sales@realmanage.com" class="email-link">
            sales&#64;realmanage.com
          </a>
          .
        </p>
      </article>
    </section>
  </div>
</app-static-page-layout>
